import { useState } from 'react';
import DashboardList from './List.jsx';
import DashboardFilters from './Form.jsx';
import DashboardDetail from './Detail.jsx';

export default function AtencionDashboardPage() {
  const [filters, setFilters] = useState({ desde: '', hasta: '' });
  const [view, setView] = useState('list');
  const [selection, setSelection] = useState(null);

  if (view === 'filters') {
    return (
      <DashboardFilters
        initialFilters={filters}
        onApply={(next) => {
          setFilters(next);
          setView('list');
        }}
        onCancel={() => setView('list')}
      />
    );
  }

  if (view === 'detail' && selection) {
    return (
      <DashboardDetail
        selection={selection}
        onBack={() => {
          setView('list');
          setSelection(null);
        }}
      />
    );
  }

  return (
    <DashboardList
      filters={filters}
      onChangeFilters={() => setView('filters')}
      onSelect={(item) => {
        setSelection(item);
        setView('detail');
      }}
    />
  );
}
